























































import {Component, Vue} from 'vue-property-decorator';
import {login} from '@/api/authApi';
import authModule from '@/store/modules/authModule';
import {updateAppAbility} from '@/abilities/ability';
import {getVersion} from '@/api/versionApi';

@Component({})
export default class FormLogin extends Vue {
  loading = false;

  isLoging = false;

  showDialog = true;

  rememberMe = false;

  username = '';
  password = '';

  accessError = '';

  valid = true;

  app_name = 'Opti-Repair';

  async created() {
    const data = await getVersion();
    if (data) {
      this.app_name = data['name'];
    }
    document.title = this.app_name;
  }

  async onLogin() {
    try {
      const form = this.$refs.form as any;

      if (form.validate()) {
        const formData = new FormData();
        formData.set('username', this.username);
        formData.set('password', this.password);
        formData.set('remember_me', this.rememberMe ? 'true' : 'false');

        this.accessError = '';

        this.isLoging = true;
        const data = await login(formData);

        if (data.response?.status > 400) {
          this.accessError = 'Неверные логин или пароль!';
          return;
        }

        if (data?.access_token) {
          authModule.setAccessToken(data.access_token);
          authModule.setLoggedInUser(this.username);
          const previousRoute = authModule.getPreviousRoute;
          if (
            previousRoute &&
            !previousRoute.includes('emptyPage') &&
            !previousRoute.includes('pageNotFound') &&
            !previousRoute.includes('login')
          )
            await this.$router.push(previousRoute);
          else await this.$router.push({path: '/'});
          this.$dataSocketManager.closeConnection();
          this.$dataSocketManager.connect();
        }

        if (data?.scopes) {
          authModule.setPermissions(data.scopes);
          updateAppAbility(this);
        }
      }
    } catch {
      this.isLoging = false;
    } finally {
      this.isLoging = false;
    }
  }
}
